import type { EdsCategoryCloseEventPayload } from '@/features/eds/components/EdsCategories/events/types/EdsCategoryCloseEventPayload';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EdsCategoryCloseEvent extends EventV2<EdsCategoryCloseEventPayload> {}
